// How a track's "artist" line reads in the player. Gym announcements are
// tagged ADVERTISING in their files; show it as "Advertising" (not shouted).
export const AD_TYPES = ['message', 'promotion', 'motivation', 'gymname']

export function isAdvert (track) {
  return !!track && AD_TYPES.indexOf(track.type) >= 0
}

export function displayArtist (track) {
  if (!track) return undefined
  const viewType = track.viewType || track.type || ''
  if (track.type === 'message' || viewType === 'gymname-message') {
    return 'Advertising'
  }
  return track.artist || undefined // undefined keeps the header's 'Loading ...'
}
